import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classnames from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Snackbar from '@material-ui/core/Snackbar';

import AssignmentInd from "@material-ui/icons/AssignmentInd";
import Check from "@material-ui/icons/Check";

import Header from "../../components/Header/Header.jsx";
import HeaderLinks from "../../components/Header/HeaderLinks.jsx";
import Footer from "../../components/Footer/Footer.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import InfoArea from "../../components/InfoArea/InfoArea.jsx";
import CustomInput from "../../components/CustomInput/CustomInput.jsx";

import CustomNotification from "../LandingPage/Sections/CustomNotification";

import signupPageStyle from "../../assets/jss/material-kit-pro-react/views/signupPageStyle.jsx";

import { registerUser } from "../../actions/authActions";
import image from "../../assets/img/landing-bg.jpg";

class SignupPage extends React.Component {
    constructor() {
        super();
        this.state = {
            openNotification: false,
            variantNotification: '',
            messageNotification: '',
            first_name: '',
            last_name: '',
            username: '',
            email: '',
            phone: '',
            password: '',
            passwordConfirmation: '',
            errors: {},
            checked: [1]
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.authReducer.isAuthenticated) {
            /*
            TODO: Crear vista dashboard
            * */
            this.props.history.push({ pathname: '/profile', state: { message: 'Ya tienes una sesión iniciada', type: 'warning' } });
        }

        if (!!nextProps.errors && !!nextProps.errors.message) {
            this.handleClickNotification(nextProps.errors.message, 'error');
            let errors = {};
            if (!!nextProps.errors.errors && nextProps.errors.errors.length>0) {
                for (let i=0; i<nextProps.errors.errors.length; i++) {
                    let actualField = nextProps.errors.errors[i];
                    errors[actualField.field] = actualField.message;
                }
                this.setState({ errors });
            }
        }
    }

    componentDidMount() {
        if (this.props.authReducer.isAuthenticated) {
            /*
            TODO: Crear vista dashboard
            * */
            this.props.history.push({ pathname: '/profile', state: { message: 'Ya tienes una sesión iniciada', type: 'warning' } });
        }

        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    }

    handleClickNotification = (messageNotification, variantNotification) => {
        this.setState({ openNotification: true, messageNotification, variantNotification });
    };

    handleCloseNotification = (event, reason) => {
        if (reason === 'clickaway') { return; }
        this.setState({ openNotification: false });
    };

    handleToggle = value => {
        const { checked } = this.state;
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        currentIndex === -1 ? newChecked.push(value) : newChecked.splice(currentIndex, 1);

        this.setState({ checked: newChecked });
    };

    onChangeCustomInput = () => e => {
        if (!!e.target.id) {
            if (e.target.id==='first_name') {
                this.setState({ username: e.target.value.toLowerCase().replace(/ /g,'') });
            }
            this.setState({ [e.target.id]: e.target.value, errors: {} });
        } else {
            console.error('Error actualizando la informacion ingresada', 'error');
        }
    };

    onSubmit = e => {
        e.preventDefault();

        const { first_name, last_name, email, username, phone, password, passwordConfirmation, checked } = this.state;

        if (checked.length > 0) {
            if (password !== '' && passwordConfirmation!=='') {
                if (password === passwordConfirmation) {
                    if (password.length>=6 && passwordConfirmation.length>=6) {
                        if (phone!=='') {

                            let newUser = {
                                first_name,
                                last_name,
                                email,
                                username,
                                phone,
                                password
                            };

                            // WithRouter nos permite pasar this.props.history como parámetro
                            this.props.registerUser(newUser, this.props.history);

                        } else {
                            let errors = { phone:"Ingresa un número de teléfono" };
                            this.setState({ errors });
                        }
                    } else {
                        let errors = {
                            password:"La Contraseña debe tener mínimo 6 caracteres",
                            passwordConfirmation:"La Contraseña debe tener mínimo 6 caracteres"
                        };
                        this.setState({ errors });
                    }
                } else {
                    let errors = {
                        password:"Los campos no coinciden",
                        passwordConfirmation:"Los campos no coinciden"
                    };
                    this.setState({ errors });
                    this.handleClickNotification('La contraseña y la confirmación de contraseña deben coincidir', 'warning');
                }
            } else {
                let errors = {
                    password:"Diligencia este campo",
                    passwordConfirmation:"Diligencia este campo"
                };
                this.setState({ errors });
                this.handleClickNotification('Por favor ingresa la contraseña y la confirmación de contraseña', 'warning');
            }
        } else {
            this.handleClickNotification('Debes aceptar los Términos y Condiciones', 'warning');
        }
    };

    render() {
        const { classes } = this.props;
        const { errors } = this.state;

        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Registro de Usuario | Vivamos el Campo - Turismo Rural</title>
                    <link rel="canonical" href="https://vivamoselcampo.co/signup" />
                    <meta name="description" content="Crea tu cuenta, únete a la comunidad de Vivamos el Campo - Turismo Rural y gestiona tus reservas e información de interés." />
                </Helmet>

                <Header
                    fixed
                    brand="Vivamos el Campo Logo"
                    color="transparent"
                    links={<HeaderLinks dropdownHoverColor="info"/>}
                    changeColorOnScroll={{
                        height: 100,
                        color: "white"
                    }}
                />
                <div
                    className={classes.pageHeader}
                    style={{
                        backgroundImage: "url(" + image + ")",
                        backgroundSize: "cover",
                        backgroundPosition: "top center"
                    }}
                >
                    <div className={classes.container}>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={7} md={7}>
                                <Card className={classes.cardSignup}>
                                    {/* Custom Notification */}
                                    <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={this.state.openNotification} autoHideDuration={6000} onClose={this.handleCloseNotification}>
                                        <CustomNotification onClose={this.handleCloseNotification} variant={this.state.variantNotification} message={this.state.messageNotification}/>
                                    </Snackbar>
                                    {/* End Custom Notification */}

                                    <h2 className={classes.cardTitle}>Registro</h2>

                                    <CardBody>
                                        <form className={classes.form} onSubmit={this.onSubmit}>
                                            <GridContainer justify="center">
                                                <GridItem xs={12} sm={12} md={12}>
                                                    <InfoArea
                                                        className={classes.infoArea}
                                                        title="Crea tu cuenta"
                                                        description="A través de tu cuenta podrás gestionar tu información personal y acceder a los servicios que te brinda la plataforma de Vivamos el Campo.
                                                        Recuerda que el registro es gratuito."
                                                        icon={AssignmentInd}
                                                        iconColor="success"
                                                    />
                                                </GridItem>
                                                <GridItem xs={12} sm={5} md={5}>
                                                    {/*<div className={classes.textCenter}>
                                                    <Button justIcon round color="twitter">
                                                        <i
                                                            className={classes.socials + " fab fa-twitter"}
                                                        />
                                                    </Button>
                                                    {` `}
                                                    <Button justIcon round color="dribbble">
                                                        <i
                                                            className={classes.socials + " fab fa-dribbble"}
                                                        />
                                                    </Button>
                                                    {` `}
                                                    <Button justIcon round color="facebook">
                                                        <i
                                                            className={classes.socials + " fab fa-facebook-f"}
                                                        />
                                                    </Button>
                                                    {` `}
                                                    <h4 className={classes.socialTitle}>
                                                        or be classical
                                                    </h4>
                                                </div>*/}

                                                    <CustomInput
                                                        id = "first_name"
                                                        formControlProps={{ fullWidth: true, className: classes.customFormControlClasses }}
                                                        labelText= {!!errors.first_name ? errors.first_name : "Nombre(s) *"}
                                                        error = {!!errors.first_name}
                                                        inputProps={{
                                                            value: this.state.first_name,
                                                            onChange: this.onChangeCustomInput(),
                                                            required: true
                                                        }}
                                                    />
                                                    <CustomInput
                                                        id = "last_name"
                                                        formControlProps={{ fullWidth: true, className: classes.customFormControlClasses }}
                                                        labelText= {!!errors.last_name ? errors.last_name : "Apellidos *"}
                                                        error = {!!errors.last_name}
                                                        inputProps={{
                                                            value: this.state.last_name,
                                                            onChange: this.onChangeCustomInput(),
                                                            required: true
                                                        }}
                                                    />
                                                    <CustomInput
                                                        id = "email"
                                                        formControlProps={{ fullWidth: true, className: classes.customFormControlClasses }}
                                                        labelText= {!!errors.email ? errors.email : "Email *"}
                                                        error = {!!errors.email}
                                                        inputProps={{
                                                            type: "email",
                                                            value: this.state.email,
                                                            onChange: this.onChangeCustomInput(),
                                                            required: true
                                                        }}
                                                    />
                                                    <CustomInput
                                                        id = "phone"
                                                        formControlProps={{ fullWidth: true, className: classes.customFormControlClasses }}
                                                        labelText= {!!errors.phone ? errors.phone : "Número celular *"}
                                                        error = {!!errors.phone}
                                                        inputProps={{
                                                            value: this.state.phone,
                                                            onChange: this.onChangeCustomInput(),
                                                            required: true
                                                        }}
                                                    />
                                                </GridItem>

                                                <GridItem xs={12} sm={5} md={5}>
                                                    <CustomInput
                                                        id = "username"
                                                        formControlProps={{ fullWidth: true, className: classes.customFormControlClasses }}
                                                        labelText= {!!errors.username ? errors.username : "Nombre de usuario *"}
                                                        error = {!!errors.username}
                                                        inputProps={{
                                                            value: this.state.username,
                                                            onChange: this.onChangeCustomInput(),
                                                            required: true
                                                        }}
                                                    />
                                                    <CustomInput
                                                        id = "password"
                                                        formControlProps={{ fullWidth: true, className: classes.customFormControlClasses }}
                                                        labelText= {!!errors.password ? errors.password : "Contraseña *"}
                                                        error = {!!errors.password}
                                                        inputProps={{
                                                            type: "password",
                                                            value: this.state.password,
                                                            onChange: this.onChangeCustomInput(),
                                                            required: true
                                                        }}
                                                    />
                                                    <CustomInput
                                                        id = "passwordConfirmation"
                                                        formControlProps={{ fullWidth: true, className: classes.customFormControlClasses }}
                                                        labelText= {!!errors.passwordConfirmation ? errors.passwordConfirmation : "Confirma la contraseña *"}
                                                        error = {!!errors.passwordConfirmation}
                                                        inputProps={{
                                                            type: "password",
                                                            value: this.state.passwordConfirmation,
                                                            onChange: this.onChangeCustomInput(),
                                                            required: true
                                                        }}
                                                    />
                                                </GridItem>

                                                <GridItem xs={12} sm={5} md={5} className={classes.topSpaced}>
                                                    <FormControlLabel
                                                        classes={{ label: classes.label }}
                                                        control={
                                                            <Checkbox
                                                                tabIndex={-1}
                                                                onClick={() => this.handleToggle(1)}
                                                                checkedIcon={ <Check className={classes.checkedIcon} /> }
                                                                icon={ <Check className={classes.uncheckedIcon} /> }
                                                                classes={{ checked: classes.checked }}
                                                                checked={ this.state.checked.indexOf(1) !== -1 }
                                                            />
                                                        }
                                                        label={ <span> Al continuar, acepto los{" "}<a href="/terminos-y-condiciones" target="_blank">Términos y Condiciones</a>.</span> }
                                                    />
                                                </GridItem>
                                                <GridItem xs={12} sm={5} md={5} className={classes.topSpaced}>
                                                    <div className={classes.textCenter}>
                                                        <Button round color="success" type="submit">
                                                            Registrarme
                                                        </Button>
                                                    </div>
                                                </GridItem>

                                                <GridItem xs={12} sm={12} md={12} className={classnames(classes.topSpaced, classes.textCenter)}>
                                                    <span>¿Ya tienes una cuenta?</span>
                                                    <Link to="/login">
                                                        <Button simple color="success" size="lg">
                                                            Inicia sesión
                                                        </Button>
                                                    </Link>
                                                </GridItem>
                                            </GridContainer>
                                        </form>

                                    </CardBody>
                                </Card>
                            </GridItem>
                        </GridContainer>
                    </div>

                    <Footer
                        className={classes.footer}
                        content={
                            <div>
                                <div className={classes.left}>
                                    <List className={classes.list}>
                                        <ListItem className={classes.inlineBlock}>
                                            <Link to="/" className={classes.block} >
                                                Inicio
                                            </Link>
                                        </ListItem>
                                        <ListItem className={classes.inlineBlock}>
                                            <Link to="/login" className={classes.block} >
                                                Iniciar Sesión
                                            </Link>
                                        </ListItem>
                                        <ListItem className={classes.inlineBlock}>
                                            <Link to="/contacto" className={classes.block} >
                                                Contacto
                                            </Link>
                                        </ListItem>
                                    </List>
                                </div>

                                <div className={classes.right}> &copy; {1900 + new Date().getYear()} Vivamos el Campo. Todos los derechos reservados.</div>
                            </div>
                        }
                    />
                </div>
            </div>
        );
    }
}

SignupPage.propTypes = {
    registerUser: PropTypes.func.isRequired,
    authReducer: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    // armamos un objeto solo con los datos del store que nos interesan y lo devolvemos
    authReducer: state.authReducer,
    errors: state.errors
});

// const mapDispatchToProps = dispatch => ({
//     registerUser(user) {
//         dispatch(registerUser(accommodation._id));
//     }
// });

export default connect(mapStateToProps, { registerUser })( withRouter( withStyles(signupPageStyle)(SignupPage) ) );



// WEBPACK FOOTER //
// ./src/views/SignupPage/SignupPage.jsx